export const SPINNER_ENGAGED = 'Spinner Engaged';
export const PRE_ORDER_CANCELED = 'Pre-order Cancelled';
